export enum TransactionLinks {
  AddSpending = "addSpending",
  AddAttachment = "addAttachment",
  GetSpendings = "getSpendings",
  GetAttachments = "getAttachments",
}
